import { render } from "./WrapGrads.vue?vue&type=template&id=2ce913bc&scoped=true"
import script from "./WrapGrads.vue?vue&type=script&lang=js"
export * from "./WrapGrads.vue?vue&type=script&lang=js"

import "./WrapGrads.vue?vue&type=style&index=0&id=2ce913bc&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ce913bc"]])

export default __exports__